<template>
    <section class="row mt-3 section-news">
        <div class="container" v-if="inFetching">
            <div class="row">
                <div class="col-12 text-center">
                    <div class="spinner-grow text-green" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="container" v-else>
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <h1 class="section-title">{{ news.postTitle }}</h1>
                    </div>
                </div>
            </div>
            <div class="row mt-lg-3 justify-content-center news-description">
                Đăng lúc {{ news.postCreatedAt }}
            </div>
            <div class="row mt-3 text-justify news-content" v-html="news.postContent"></div>
        </div>
    </section>
</template>

<script>
    /**
     * Import modules
     */
    import api from '../../api';

    export default {
        name: "NewsDetailComponent",
        data() {
            return {
                inFetching: false,
                news: {
                    postTitle: ''
                }
            }
        },
        async mounted() {
            // set inFetching mode
            this.inFetching = true;

            // get slug
            let slug = this.$route.params.slug;

            // get news by slug
            api.getNews(slug)
                .then((response) => {
                    this.news = response.data.data;
                })
                .finally(() => {
                    // release inFetching mode
                    this.inFetching = false;
                })
        }
    }
</script>

<style lang="less" scoped>

</style>
